import React, { useEffect } from "react";
import { Col, Modal, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import TranslateText from "../../TranslateText";
import { groupNotificationSelector } from "../../../../services/selector/index.";
import "../../../../assets/style/modalStyle/detailProduct.scss";
import LabelInput from "../../LabelInput";
import {
  getDetailGroupNotify,
  setOpenDetailGroupNotification,
  setOpenEditGroupNotification,
} from "../../../../services/slice/GroupNotificationSlice";
import { IconEditWhite } from "../../../../assets/icon";
import BaseButton from "../../Button/BaseButton";
import { formatDate } from "../../../../utils/functionCommon";
import EditorText from "../../EditorText";
const ModalDetailGroupNotification = ({ title }) => {
  const dispatch = useDispatch();
  const stateGroupNotification = useSelector(groupNotificationSelector);
  const { idGroupNotification, isOpenModalDetail, dataDetailGroupNotify } =
    stateGroupNotification;
  useEffect(() => {
    dispatch(getDetailGroupNotify(idGroupNotification));
  }, [dispatch]);

  const handleEditGroupNotification = () => {
    dispatch(
      setOpenDetailGroupNotification({ isOpen: false, id: idGroupNotification })
    );
    dispatch(
      setOpenEditGroupNotification({ isOpen: true, id: idGroupNotification })
    );
  };

  const handCancel = () => {
    dispatch(setOpenDetailGroupNotification({ isOpen: false, id: "" }));
  };

  const scope =
    dataDetailGroupNotify.scope === 0
      ? "Toàn bộ KH"
      : dataDetailGroupNotify.scope === 1
      ? "KH thuộc đại lý"
      : dataDetailGroupNotify.scope === 2
      ? "KH online"
      : dataDetailGroupNotify.scope === 3
      ? "KH không bản quyền"
      : "";
  const limit =
    dataDetailGroupNotify.customerType === 0
      ? "Toàn bộ KH"
      : dataDetailGroupNotify.customerType === 1
      ? "Nhóm"
      : "";
  return (
    <>
      <Modal
        // className="wrapperDetailChatBkavPro"
        title={<TranslateText text={title} />}
        centered
        width={1000}
        open={isOpenModalDetail}
        onCancel={handCancel}
        footer={[
          <BaseButton
            content={"Chỉnh sửa"}
            width={140}
            typeBtn="btnOrange"
            icon={<IconEditWhite />}
            handleClick={handleEditGroupNotification}
          />,
        ]}
      >
        <Row style={{ display: "flex" }}>
          <Col span={5}>
            {" "}
            <LabelInput text={"Tiêu đề"} style={{ textAlign: "start" }} />
          </Col>
          <Col span={18}>{dataDetailGroupNotify?.title}</Col>
        </Row>
        {/*  */}
        <Row
          style={{ display: "flex", marginTop: "22px", marginBottom: "8px" }}
        >
          <Col span={5}>
            {" "}
            <LabelInput
              text={"Nội dung tin nhắn"}
              style={{ textAlign: "start" }}
            />
          </Col>
          {dataDetailGroupNotify.type === 0 ? (
            <>
              <Col span={18}>
                <EditorText
                  placeholder={"Nội dung trống"}
                  text={dataDetailGroupNotify?.content}
                  height={'fit-content'}
                />
              </Col>
            </>
          ) : (
            <>
              <Col span={18}>
                <img
                  onClick={() => {
                    if (dataDetailGroupNotify.redirectUrl) {
                      window.open(dataDetailGroupNotify.redirectUrl, "_blank");
                    }
                  }}
                  src={`${
                    dataDetailGroupNotify.filename
                      ? window.SERVER_URL
                      : window.SERVER_URL
                  }/api/image/resources/${dataDetailGroupNotify.filename}`}
                  alt="img"
                  style={{ width: 500, cursor: "pointer" }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row style={{ display: "flex", marginBottom: "8px" }}>
          <Col span={5}>
            {" "}
            <LabelInput
              text={"Thời gian bắt đầu"}
              style={{ textAlign: "start" }}
            />
          </Col>
          <Col span={18}>
            <TextInput
              text={formatDate(dataDetailGroupNotify?.startTime)}
            ></TextInput>
          </Col>
        </Row>
        <Row style={{ display: "flex", marginBottom: "8px" }}>
          <Col span={5}>
            {" "}
            <LabelInput
              text={"Thời gian kết thúc"}
              style={{ textAlign: "start" }}
            />
          </Col>
          <Col span={18}>
            <TextInput
              text={formatDate(dataDetailGroupNotify?.endTime)}
            ></TextInput>
          </Col>
        </Row>
        <Row style={{ display: "flex", marginBottom: "8px" }}>
          <Col span={5}>
            {" "}
            <LabelInput text={"Ngày tạo"} style={{ textAlign: "start" }} />
          </Col>
          <Col span={18}>
            <TextInput
              text={formatDate(dataDetailGroupNotify?.createdAt)}
            ></TextInput>
          </Col>
        </Row>
        <Row style={{ display: "flex", marginBottom: "8px" }}>
          <Col span={5}>
            {" "}
            <LabelInput
              text={"Đối tượng hiển thị"}
              style={{ textAlign: "start" }}
            />
          </Col>
          <Col span={18}>
            <TextInput text={scope}></TextInput>
          </Col>
        </Row>
        <Row style={{ display: "flex", marginBottom: "8px" }}>
          <Col span={5}>
            {" "}
            <LabelInput
              text={"Phạm vi hiển thị"}
              style={{ textAlign: "start" }}
            />
          </Col>
          <Col span={18}>
            <TextInput text={limit}></TextInput>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ModalDetailGroupNotification;

export const TextInput = ({ text, style }) => {
  return (
    <span
      style={{
        display: "block",
        width: "100%",
        textAlign: "start",
        fontWeight: 400,
        fontFamily: "Roboto",
        fontSize: "14px",
        ...style,
      }}
    >
      <TranslateText text={text} />
    </span>
  );
};
